

















import { Component, Vue, Watch } from 'vue-property-decorator'

@Component({})
export default class TelaDeNovidades extends Vue {
	carregando = true
	iframeSrc = ''

	created() {
		this.reloadIframe()
	}
	
	reloadIframe() {
		this.carregando = true		
		this.iframeSrc = ''
		setTimeout(() => {
			this.iframeSrc = 'https://almode.gitbook.io/almode-pdv'
		}, 100)
	}

	onIframeLoad() {
		this.carregando = false
		
		// Método para enviar dados para o localStorage do iframe
		this.setIframeLocalStorage('theme', this.$vuetify.theme.dark ? 'dark' : 'light')
	}

	setIframeLocalStorage(key: string, value: any) {
		const iframe = document.querySelector('.vue-friendly-iframe iframe')
		if (iframe) {
			// Enviando mensagem para o iframe

			(iframe as HTMLIFrameElement).contentWindow?.postMessage(
				{
					type: 'setLocalStorage',
					data: {
						key,
						value: JSON.stringify(value),
					},
				},
				'*'
			)
		}
	}

	@Watch('$vuetify.theme.dark')
	onChangeTheme() {
		this.setIframeLocalStorage('theme', this.$vuetify.theme.dark ? 'dark' : 'light')
	}
}
